import React, { memo, useCallback, useMemo } from 'react';
import { Tooltip, Icon, createUseStyles } from '@Sage/hoi-poi-ui';
import { useWeb5Context } from 'lib/Web5Context';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'ReadOnly');

const ReadOnly = ({ api, context, data, eGridCell, node, customTooltip }) => {
    const { t } = useWeb5Context();
    const classes = useStyles();

    const elementId = useMemo(() => {
        const tableId = context?.tableId || '';
        return tableId ? `w5-actions-component-${tableId}` : 'w5-actions-component';
    }, [context]);

    const actionsWrapper = useMemo(() => document.getElementById(elementId), [elementId]);

    const getBodyViewPort = useCallback(() => {
        const tableDiv = context?.tableRef?.current?.eGridDiv || null;
        let bodyViewport = api.gridBodyCtrl.eBodyViewport;
        if (tableDiv) {
            bodyViewport = tableDiv.querySelector('.ag-body-viewport');
        }
        return bodyViewport;
    }, [api.gridBodyCtrl.eBodyViewport, context?.tableRef]);

    const handleOnMouseEnter = useCallback(() => {
        const bodyViewport = getBodyViewPort();
        const bodyViewportContent = bodyViewport.children;
        let bodyViewportContentChild;

        for (let current of bodyViewportContent) {
            if (current.classList.contains('ag-center-cols-clipper')) {
                bodyViewportContentChild = current;
            }
        }

        // We need to inform about that to add the correct style to prevent overlap the scroll bar.
        const hasScroll = bodyViewportContentChild.offsetHeight > bodyViewport.offsetHeight;

        context.getHoveredRowInfo({
            data: data,
            hasScroll,
            rowElement: eGridCell?.offsetParent,
        });

        const scrollTop = bodyViewport.scrollTop;
        actionsWrapper.style.display = 'block';
        const centerElement = 40 - scrollTop;
        const actionsTop = node.rowTop + centerElement;
        actionsWrapper.style.top = `${actionsTop + 3}px`;
        actionsWrapper.style.height = `${node.rowHeight - 2}px`;
    }, [
        actionsWrapper.style,
        context,
        data,
        eGridCell?.offsetParent,
        getBodyViewPort,
        node.rowHeight,
        node.rowTop,
    ]);

    const handleOnMouseLeave = useCallback(() => {
        actionsWrapper.style.display = 'none';
    }, [actionsWrapper.style]);

    const rootProps = useMemo(
        () => ({
            className: classes.root,
            onMouseEnter: handleOnMouseEnter,
            onMouseLeave: handleOnMouseLeave,
        }),
        [classes.root, handleOnMouseEnter, handleOnMouseLeave],
    );

    const tooltipProps = useMemo(
        () => ({
            placement: 'top',
            content: t(customTooltip || 'label_necessary_for_sage'),
        }),
        [customTooltip, t],
    );

    return (
        <div {...rootProps}>
            {data?.readOnly ? (
                <Tooltip {...tooltipProps}>
                    <span>
                        <Icon name="lock" />
                    </span>
                </Tooltip>
            ) : null}
        </div>
    );
};

export default memo(ReadOnly);
